/* Shared storefront state. Publish only with the matching IIG public route. */
(function () {
  'use strict';
  if (window.IIGPromotionState) return;
  var language = String(document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  var value = { active: false, state: 'unavailable', revision: null };
  var clockOffset = 0;
  var boundaryTimer;
  var inFlight = null;
  function read() {
    var now = Date.now() + clockOffset;
    return Object.assign({}, value, { active: value.active === true && now >= value.starts_at * 1000 && now < value.ends_at * 1000 });
  }
  function notify() {
    window.dispatchEvent(new CustomEvent('iig:promotion-state', { detail: read() }));
  }
  function accept(payload) {
    if (!payload || payload.language !== language || payload.campaign !== 'complete-look-2-plus-1' || !Number.isFinite(payload.server_time) || !Number.isFinite(payload.starts_at) || !Number.isFinite(payload.ends_at) || payload.ends_at <= payload.starts_at || typeof payload.active !== 'boolean' || typeof payload.revision !== 'string' || typeof payload.title !== 'string' || typeof payload.terms !== 'string' || payload.title.length > 240 || payload.terms.length > 20000) throw new Error('Invalid promotion state');
    clockOffset = payload.server_time * 1000 - Date.now();
    value = { active: payload.active && payload.state === 'active', state: payload.state, revision: payload.revision, starts_at: payload.starts_at, ends_at: payload.ends_at, title: payload.title, terms: payload.terms };
    clearTimeout(boundaryTimer);
    var remaining = payload.ends_at * 1000 - (Date.now() + clockOffset);
    if (read().active && remaining > 0) boundaryTimer = setTimeout(notify, Math.min(remaining, 2147483647));
    notify();
  }
  function refresh() {
    if (inFlight) return inFlight;
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 8000);
    inFlight = fetch('https://api.leposse.com/v1/promotions/complete-look?language=' + encodeURIComponent(language), { cache: 'no-store', credentials: 'omit', signal: controller.signal, headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Promotion unavailable'); return response.json(); })
      .then(accept).catch(function () { value = { active: false, state: 'unavailable', revision: null }; clearTimeout(boundaryTimer); notify(); })
      .finally(function () { clearTimeout(timeout); inFlight = null; });
    return inFlight;
  }
  window.IIGPromotionState = { read: read, refresh: refresh };
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  function poll() { refresh().finally(function () { setTimeout(poll, 60000); }); }
  poll();
})();
